import RichText from "@/components/RichText";
import { CONTAINER, EYEBROW_LIGHT } from "../tokens";

// Plan d'accès : sur-titre « Accès », H2 « Un atelier au cœur du 17e »,
// image du plan pleine largeur avec filet 1px.
export default function AccessMapSection({ props = {} }) {
  if (!props.image_url && !props.heading) return null;
  return (
    <section id="acces" className="scroll-mt-[90px]">
      <div className={`${CONTAINER} px-5 md:px-11 py-14`}>
      <RichText as="div" className={`${EYEBROW_LIGHT} mb-3`} html={props.eyebrow} />
      <RichText
        as="h2"
        className="block font-display font-light text-[clamp(24px,2.8vw,34px)] leading-[1.2] text-ink mb-7"
        html={props.heading}
      />
      {props.image_url && (
        <img
          src={props.image_url}
          alt={props.alt || ""}
          className="w-full h-auto block border border-ink/[0.12]"
          loading="lazy"
        />
      )}
      </div>
    </section>
  );
}
